<template>
  <div>
    <div class="wizard">
      <div class="row mt-4">
        <div class="col-12">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              :class="{'wizard-step-active': step === 1, 'wizard-step-completed': step > 1, 'disabled': step < 1}"
            >
              <div class="wizard-step-icon">
                <i
                  v-if="step > 1"
                  class="fas fa-check"
                />
                <i
                  v-else
                  class="fas fa-th"
                />
              </div>
              <div class="wizard-step-label">
                Pilih Paket
              </div>
            </div>
            <div
              class="wizard-step"
              :class="{'wizard-step-active': step === 2, 'wizard-step-completed': step > 2, 'disabled': step < 2}"
            >
              <div class="wizard-step-icon">
                <i
                  v-if="step > 2"
                  class="fas fa-check"
                />
                <i
                  v-else
                  class="fas fa-th-list"
                />
              </div>
              <div class="wizard-step-label">
                Pilih Layanan
              </div>
            </div>
            <div
              class="wizard-step"
              :class="{'wizard-step-active': step === 3, 'wizard-step-completed': step > 3, 'disabled': step < 3}"
            >
              <div class="wizard-step-icon">
                <i
                  v-if="step > 3"
                  class="fas fa-check"
                />
                <i
                  v-else
                  class="fas fa-pencil-alt"
                />
              </div>
              <div class="wizard-step-label">
                Pengisian Formulir
              </div>
            </div>
            <div
              class="wizard-step"
              :class="{'wizard-step-active': step === 4, 'wizard-step-completed': step > 4, 'disabled': step < 4}"
            >
              <div class="wizard-step-icon">
                <i
                  v-if="step > 4"
                  class="fas fa-check"
                />
                <i
                  v-else
                  class="fas fa-print"
                />
              </div>
              <div class="wizard-step-label">
                Cetak Formulir
              </div>
            </div>
            <div
              class="wizard-step"
              :class="{'wizard-step-active': step === 5, 'wizard-step-completed': step > 5, 'disabled': step < 5}"
            >
              <div class="wizard-step-icon">
                <i
                  v-if="step > 5"
                  class="fas fa-check"
                />
                <i
                  v-else
                  class="fas fa-upload"
                />
              </div>
              <div class="wizard-step-label">
                Upload Berkas
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
    .wizard-step {
        cursor: pointer;
        transition: all .3s;
    }
    .wizard-steps .wizard-step.wizard-step-active, .wizard-steps .wizard-step.wizard-step-active:before {
        background-color: #ffa426;
    }
    .wizard-steps .wizard-step.wizard-step-completed {
        background-color: #47c363;
        color: white
    }
    .wizard-steps .wizard-step.wizard-step-completed:before {
        background-color: #47c363;
    }

    .wizard-step:hover, .wizard-step.wizard-step-active:hover {
        cursor: pointer;
        color: #fff;
    }

    .wizard-step:hover {
        background-color: #6777ef;
    }
    .wizard-step.wizard-step-active:hover {
        background-color: #ffa426;
    }

    .wizard-step:hover::before, .wizard-step.wizard-step-active:hover::before {
        color: #fff;
    }

    .wizard-step:hover::before {
        background-color: #6777ef;
    }
    .wizard-step.wizard-step-active:hover::before {
        background-color: #ffa426;
    }

    
    .wizard-step.disabled {
        cursor: no-drop;
    }
    .wizard-step.disabled:hover {
        cursor: no-drop;
        background-color: #fff;
        color: #6c757d;
    }
    .wizard-step:hover::before {
        background-color: #e3eaef;
        color: #6c757d;
    }
    @media (max-width: 575.98px){
        .wizard-steps .wizard-step {
            margin-bottom: 0;
        }
    }

    @media (max-width: 575.98px){
        .wizard-steps {
            display: flex;
        }
        .wizard-steps .wizard-step .wizard-step-label {
            display: none;
        }
        .wizard-steps .wizard-step {
            padding: 10px;
            margin: 0 5px;
        }
        .wizard-steps .wizard-step .wizard-step-icon .fas, .wizard-steps .wizard-step .wizard-step-icon .far, .wizard-steps .wizard-step .wizard-step-icon .fab, .wizard-steps .wizard-step .wizard-step-icon .fal, .wizard-steps .wizard-step .wizard-step-icon .ion{
            font-size: 14px;
        }
    }

</style>

<script>
export default {
    name: 'Step',
    data(){
        return {

        }
    },
    computed: {
        step(){
            return this.$store.getters.getDataPermohonan.tahap
        }
    },
    created(){
        // console.log(this.step)
    },
    methods: {
        setStep(val){
            let dataPermohonan = this.$store.getters.getDataPermohonan
            dataPermohonan.tahap = val
            this.$store.dispatch('setDataPermohonan', dataPermohonan)
        }
    }
}
</script>